import { useSelector } from "react-redux";
import Modal from "../../components/Modal";
import Stats from "./views/Stats";
import Date from "./views/Date";
import Fixtures from "./views/Fixtures";
import SortBy from "./views/SortBy";
import Markets from "./views/Markets";
import Odds from "./views/Odds";
import Favourites from "./views/Favourites";
import CombinedFilters from "./views/CombinedFilters";

const FilterMap = new Map([
  ["odds", <Odds key="odds" />],
  ["stats", <Stats key="stats" />],
  ["date", <Date key="date" />],
  ["fixtures", <Fixtures key="fixtures" />],
  ["sortBy", <SortBy key="sort" />],
  ["markets", <Markets key="markets" />],
  ["favourites", <Favourites key="favourites" />],
  ["combinedFilters", <CombinedFilters key="combinedFilters" />],
]);

const Filter = () => {
  const { activeFilterView } = useSelector((state) => state.view);
  if (!activeFilterView) return null;
  return <Modal variant="filter">{FilterMap.get(activeFilterView)}</Modal>;
};

export default Filter;
